var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666667 14.8333L2.53333 5.43333L1.33333 5.9V8.16667H0V5.03333L3.36667 3.6C3.52222 3.53333 3.68611 3.49444 3.85833 3.48333C4.03056 3.47222 4.19444 3.49444 4.35 3.55C4.50556 3.60556 4.65278 3.68333 4.79167 3.78333C4.93056 3.88333 5.04444 4.01111 5.13333 4.16667L5.8 5.23333C6.08889 5.7 6.48056 6.08333 6.975 6.38333C7.46944 6.68333 8.03333 6.83333 8.66667 6.83333V8.16667C7.88889 8.16667 7.19444 8.00556 6.58333 7.68333C5.97222 7.36111 5.45 6.95 5.01667 6.45L4.6 8.5L6 9.83333V14.8333H4.66667V10.5L3.26667 9.43333L2.06667 14.8333H0.666667ZM5 3.16667C4.63333 3.16667 4.31944 3.03611 4.05833 2.775C3.79722 2.51389 3.66667 2.2 3.66667 1.83333C3.66667 1.46667 3.79722 1.15278 4.05833 0.891667C4.31944 0.630556 4.63333 0.5 5 0.5C5.36667 0.5 5.68056 0.630556 5.94167 0.891667C6.20278 1.15278 6.33333 1.46667 6.33333 1.83333C6.33333 2.2 6.20278 2.51389 5.94167 2.775C5.68056 3.03611 5.36667 3.16667 5 3.16667Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.5e9f0465763e8affa79140d5f06a1053.svg";
export { ForwardRef as ReactComponent };